import { gql } from 'apollo-angular';

export const OKTA_USER_APTITUDE_ORGS = gql`
  query OktaUserAptitudeOrgs($oktaToken: String) {
    oktaUserAptitudeOrgs(oktaToken: $oktaToken) {
      id
      name
    }
  }
`;

export type OktaUserAptitudeOrgsVariables = {
  oktaToken: string;
};
